export const messagingMessages = {
  "question-receipt.answer": "Your answer",
  "question-receipt.unavailable": "Answer unavailable",
  "question-receipt.otherChoices": "Other choices ({count})",
  "question-receipt.offeredChoices": "Choices offered ({count})",
  "interruption.question": "Your response",
  "interruption.permission": "Permission required",
  "interruption.expand": "Expand requests",
  "interruption.collapse": "Collapse requests",
  "interruption.previous": "Previous request",
  "interruption.next": "Next request",
  "interruption.global": "Service request",
  "interruption.answered": "Answered",
  "interruption.noAnswer": "No answer",
  "promptInput.skills.title": "Skills",
  "promptInput.skills.remove": "Remove skill {name}",
  "promptInput.skills.loading": "Loading skills…",
  "promptInput.skills.select": "Attach a skill…",
  "promptInput.skills.error": "Unable to load skills. Close and reopen to retry.",
  "promptInput.skills.empty": "No skills available in this directory.",
  "toolCall.image.label": "Image {number}",
  "toolCall.image.unavailable": "Unable to display this image.",
  "promptInput.btw.title": "/btw — Side question",
  "promptInput.btw.commandDescription": "Ask a side question without adding to the conversation",
  "promptInput.btw.description": "Uses this session's context in a separate model request. Questions and answers are not added to the conversation. Attachments stay in the composer.",
  "promptInput.btw.question": "Your question",
  "promptInput.btw.answer": "Answer",
  "promptInput.btw.ask": "Ask",
  "promptInput.btw.loading": "Thinking…",
  "promptInput.btw.cancel": "Cancel question",
  "promptInput.btw.close": "Close side question",
  "promptInput.btw.empty": "The model returned no text. Try rephrasing your question.",
  "promptInput.btw.failed": "Unable to answer the side question.",
  "promptInput.btw.copy": "Copy answer",
  "promptInput.btw.copied": "Copied",
  "promptInput.btw.copyFailed": "Unable to copy the answer.",
  "history.navigation.outlineLoading": "Loading full timeline… {loaded} / {total}",
  "history.navigation.loading": "Loading passage…",
  "history.navigation.outlineUnavailable": "Full timeline unavailable",
  "history.scope": "Search scope",
  "history.session": "Entire session",
  "history.workspace": "Entire workspace",
  "history.technical": "Include tools and thinking",
  "history.searchProgress": "This page: {matches} results · {messages} messages scanned",
  "history.skipped": "{count} messages could not be fully processed.",
  "history.more": "Next results",
  "history.text": "Text",
  "history.tool": "Tool",
  "history.reasoning": "Thinking",
  "history.planning": "Inspecting history: {count} messages",
  "history.pruning": "Cleaning: {count} / {total} messages",
  "transcriptFilters.title": "Message content",
  "transcriptFilters.systemMessages": "System",
  "messageBlock.system.label": "System",
  "transcriptFilters.description": "Show or hide content, then choose whether it starts expanded. These settings apply to all conversations.",
  "transcriptFilters.show": "Show {name}",
  "transcriptFilters.hide": "Hide {name}",
  "transcriptFilters.expand": "Expand {name}",
  "transcriptFilters.collapse": "Collapse {name}",
  "messageListHeader.sidebar.openSessionListAriaLabel": "Open session list",
  "messageListHeader.metrics.usedLabel": "Used",
  "messageListHeader.metrics.availableLabel": "Avail",
  "messageListHeader.commandPalette.ariaLabel": "Open command palette",
  "messageListHeader.commandPalette.button": "Command Palette",
  "messageListHeader.connection.connected": "Connected",
  "messageListHeader.connection.connecting": "Connecting...",
  "messageListHeader.connection.disconnected": "Disconnected",

  "messageSection.empty.logoAlt": "CodeNomad logo",
  "messageSection.empty.brandTitle": "CodeNomad",
  "messageSection.empty.title": "Start a conversation",
  "messageSection.empty.description": "Type a message below or open the Command Palette:",
  "messageSection.empty.tips.commandPalette": "Command Palette",
  "messageSection.empty.tips.askAboutCodebase": "Ask about your codebase",
  "messageSection.empty.tips.attachFilesPrefix": "Attach files with",
  "messageSection.loading.messages": "Loading messages...",
  "messageSection.loadError.title": "Could not load messages",
  "messageSection.loadError.detail": "OpenCode did not return the session messages.",
  "messageSection.loadError.reload": "Reload messages",
  "messageSection.scroll.toFirstAriaLabel": "Scroll to first message",
  "messageSection.scroll.toLatestAriaLabel": "Scroll to latest message",
  "messageSection.scroll.showControlsAriaLabel": "Show scroll controls",
  "messageSection.scroll.enableHoldAriaLabel": "Enable hold for long assistant replies",
  "messageSection.scroll.disableHoldAriaLabel": "Disable hold for long assistant replies",
  "messageSection.quote.addAsQuote": "Add as quote",
  "messageSection.quote.addAsCode": "Add as code",
  "messageSection.quote.copy": "Copy",
  "messageSection.quote.copied": "Copied!",
  "messageSection.quote.copyFailed": "Copy failed",
  "messageSection.search.ariaLabel": "Search chat history",
  "messageSection.search.placeholder": "Search current chat...",
  "messageSection.search.count.empty": "Search",
  "messageSection.search.count.minChars": "{count}+ chars",
  "messageSection.search.count.searching": "Searching...",
  "messageSection.search.count.none": "No matches",
  "messageSection.search.count.matches": "{current} / {total}",
  "messageSection.search.previousAriaLabel": "Previous match",
  "messageSection.search.nextAriaLabel": "Next match",
  "messageSection.search.closeAriaLabel": "Close search",
  "messageSection.search.searching": "Searching...",
  "messageSection.search.failed": "Search failed",
  "messageSection.search.retry": "Retry",
  "messageSection.search.noVisibleMatches": "No visible matches",
  "messageTimeline.ariaLabel": "Message timeline",
  "messageTimeline.segment.user.label": "You",
  "messageTimeline.segment.assistant.label": "Asst",
  "messageTimeline.segment.compaction.label": "Compaction",
  "messageTimeline.tool.fallbackLabel": "Tool Call",
  "messageTimeline.tooltip.userFallback": "User message",
  "messageTimeline.tooltip.assistantFallback": "Assistant response",
  "messageTimeline.tooltip.compaction.auto": "Auto Compaction",
  "messageTimeline.tooltip.compaction.manual": "User Compaction",
  "messageTimeline.text.filePrefix": "[File] {filename}",
  "messageTimeline.text.attachment": "Attachment",
  "messageBlock.tool.header": "Tool Call",
  "messageBlock.tool.unknown": "unknown",
  "messageBlock.tool.goToSession.label": "Go to Session",
  "messageBlock.tool.goToSession.title": "Go to session",
  "messageBlock.tool.goToSession.unavailableTitle": "Session not available yet",

  "messageBlock.compaction.ariaLabel": "Session compaction",
  "messageBlock.compaction.autoLabel": "Session auto-compacted",
  "messageBlock.compaction.manualLabel": "Session compacted by you",
  "messageBlock.usage.input": "Input",
  "messageBlock.usage.output": "Output",
  "messageBlock.usage.reasoning": "Reasoning",
  "messageBlock.usage.cacheRead": "Cache Read",
  "messageBlock.usage.cacheWrite": "Cache Write",
  "messageBlock.usage.cost": "Cost",
  "messageBlock.usage.expandAriaLabel": "Expand token metrics",
  "messageBlock.usage.collapseAriaLabel": "Collapse token metrics",
  "messageBlock.step.agentLabel": "Agent: {agent}",
  "messageBlock.step.modelLabel": "Model: {model}",
  "messageBlock.reasoning.thinkingLabel": "Thinking",
  "messageBlock.reasoning.thoughtLabel": "Thought",
  "messageBlock.reasoning.steps.one": "{count} step",
  "messageBlock.reasoning.steps.other": "{count} steps",
  "messageBlock.exploration.completed": "Explored: {tools}",
  "messageBlock.exploration.active": "Exploring: {tools}",
  "messageBlock.exploration.read.one": "{count} read",
  "messageBlock.exploration.read.other": "{count} reads",
  "messageBlock.exploration.search.one": "{count} search",
  "messageBlock.exploration.search.other": "{count} searches",
  "messageBlock.shell.completed": "Shell: {count}",
  "messageBlock.shell.active": "Shell: {count}",
  "messageBlock.reasoning.expandAriaLabel": "Expand thinking",
  "messageBlock.reasoning.collapseAriaLabel": "Collapse thinking",
  "messageBlock.reasoning.indicator.hide": "Hide",
  "messageBlock.reasoning.indicator.view": "View",
  "messageBlock.reasoning.detailsAriaLabel": "Reasoning details",
  "messageBlock.reasoning.thoughtsFallback": "Thoughts",
  "messageBlock.reasoning.thoughtFor.seconds.one": "Thought for {count} second",
  "messageBlock.reasoning.thoughtFor.seconds.other": "Thought for {count} seconds",
  "messageBlock.reasoning.thoughtFor.minutes.one": "Thought for {count} minute",
  "messageBlock.reasoning.thoughtFor.minutes.other": "Thought for {count} minutes",
  "messageBlock.reasoning.thoughtFor.hours.one": "Thought for {count} hour",
  "messageBlock.reasoning.thoughtFor.hours.other": "Thought for {count} hours",
  "messageBlock.reasoning.copyTitle": "Copy thoughts",
  "messageBlock.reasoning.copyAriaLabel": "Copy thoughts",

  "codeBlockInline.actions.copy": "Copy",
  "codeBlockInline.actions.copied": "Copied!",

  "messageItem.speaker.you": "You",
  "messageItem.speaker.assistant": "Assistant",
  "messageItem.actions.revert": "Revert",
  "messageItem.actions.revertTitle": "Undo changes up to here (deletes messages)",
  "messageItem.actions.fork": "Fork",
  "messageItem.actions.forkTitle": "Fork after this message",
  "messageItem.actions.copy": "Copy",
  "messageItem.actions.copyTitle": "Copy message",
  "messageItem.actions.copied": "Copied!",
  "messageItem.actions.more": "More actions",
  "messageItem.actions.speak": "Speak message",
  "messageItem.actions.generatingSpeech": "Generating speech",
  "messageItem.actions.stopSpeech": "Stop playback",
  "messageItem.actions.speak.error.title": "Speech playback failed",
  "messageItem.actions.speak.error.unsupported": "Speech playback is not supported in this browser.",
  "messageItem.actions.speak.error.unavailable": "Speech playback is unavailable until speech settings are configured.",
  "messageItem.actions.speak.error.generate": "Unable to generate speech for this message.",
  "messageItem.actions.deleteTechnicalParts": "Remove tools and reasoning from this response",
  "messageItem.actions.deleteTechnicalParts.confirmTitle": "Remove tools and reasoning?",
  "messageItem.actions.deleteTechnicalParts.confirmMessage": "Tool outputs: {toolCount}; reasoning blocks: {reasoningCount}. The final text will be preserved.",
  "messageItem.actions.deleteTechnicalParts.confirmLabel": "Remove",
  "messageItem.actions.deleteTechnicalParts.failedTitle": "Removal failed",
  "messageItem.actions.deleteTechnicalParts.failedMessage": "Failed to remove tools and reasoning from this response",

  "messageItem.duration.workedFor.seconds.one": "Worked for {count} second",
  "messageItem.duration.workedFor.seconds.other": "Worked for {count} seconds",
  "messageItem.duration.workedFor.minutes.one": "Worked for {count} minute",
  "messageItem.duration.workedFor.minutes.other": "Worked for {count} minutes",
  "messageItem.duration.workedFor.hours.one": "Worked for {count} hour",
  "messageItem.duration.workedFor.hours.other": "Worked for {count} hours",

  "messageItem.status.queued": "QUEUED",
  "messageItem.status.generating": "Generating...",
  "messageItem.status.sending": "Sending...",
  "messageItem.status.failedToSend": "Message failed to send",
  "messagePart.actions.delete": "Delete",
  "messagePart.actions.deleting": "Deleting...",
  "messagePart.actions.deleteFailedTitle": "Delete failed",
  "messagePart.actions.deleteFailedMessage": "Failed to delete item",
  "messagePart.pastedText.summary": "Pasted text",
  "messagePart.pastedText.lines.one": "{count} line",
  "messagePart.pastedText.lines.other": "{count} lines",
  "messagePart.pastedText.copyAriaLabel": "Copy pasted text block",
  "messageItem.attachment.defaultName": "attachment",
  "messageItem.attachment.downloadAriaLabel": "Download {name}",
  "messageItem.agentMeta.agentLabel": "Agent: {agent}",
  "messageItem.agentMeta.modelLabel": "Model: {model}",
  "messageItem.errors.authenticationFallback": "Authentication error",
  "messageItem.errors.outputLengthExceeded": "Message output length exceeded",
  "messageItem.errors.requestAborted": "Request was aborted",
  "messageItem.errors.unknownFallback": "Unknown error occurred",

  "attachmentChip.removeAriaLabel": "Remove attachment",

  "expandButton.toggleAriaLabel": "Toggle chat input height",

  "promptInput.placeholder.shell": "Run a shell command (Esc to exit)...",
  "promptInput.placeholder.default": "Type your message, @file, @agent, @skill, or paste images and text...",
  "promptInput.hints.shell.exit": "to exit shell mode",
  "promptInput.hints.shell.enable": "Shell mode",
  "promptInput.hints.commands": "Commands",
  "promptInput.history.previousAriaLabel": "Previous prompt",
  "promptInput.history.nextAriaLabel": "Next prompt",
  "promptInput.overlay.newLine": "New line",
  "promptInput.overlay.send": "Send",
  "promptInput.overlay.filesAgents": "Files/agents",
  "promptInput.overlay.history": "History",
  "promptInput.overlay.attachments": "• {count} file(s) attached",
  "promptInput.overlay.shellModeActive": "Shell mode active",
  "promptInput.overlay.press": "Press",
  "promptInput.overlay.againToAbort": "again to abort session",
  "promptInput.stopSession.ariaLabel": "Stop session",
  "promptInput.stopSession.title": "Stop session",
  "promptInput.background.title": "Move blocking tools to background (Cmd/Ctrl+B)",
  "promptInput.background.error.title": "Background action failed",
  "promptInput.background.error.message": "Unable to move blocking tools to the background",
  "promptInput.attachFiles.ariaLabel": "Attach files",
  "promptInput.attachFiles.title": "Attach file…",
  "promptInput.attachFiles.help": "Choose files from this device",
  "promptInput.attachFiles.reading": "Reading files…",
  "promptInput.hints.projectFiles": "Reference project files",
  "promptInput.attachFiles.deviceDetail": "Device: {name} · {bytes} bytes",
  "promptInput.attachFiles.projectDetail": "Project: {path}",
  "promptInput.attachFiles.rejected.tooLarge": "{name}: exceeds 5 MiB per file.",
  "promptInput.attachFiles.rejected.limit": "{name}: exceeds 10 files or 20 MiB total.",
  "promptInput.attachFiles.rejected.unreadable": "{name}: could not be read.",
  "promptInput.attachFiles.errorTitle": "Attach failed",
  "promptInput.attachFiles.skipped.title": "Some files were not attached",
  "promptInput.attachFiles.tooLarge.one": "1 selected file could not be attached because it is larger than the 5 MB attachment limit.",
  "promptInput.attachFiles.tooLarge.other": "{count} selected files could not be attached because they are larger than the 5 MB attachment limit.",
  "promptInput.attachFiles.limit.one": "1 selected file was not attached because attachments are limited to {maxFiles} files and {maxMegabytes} MB total.",
  "promptInput.attachFiles.limit.other": "{count} selected files were not attached because attachments are limited to {maxFiles} files and {maxMegabytes} MB total.",
  "promptInput.attachFiles.deviceRejected.one": "1 selected file was not attached. Files must be readable, no larger than {maxFileMegabytes} MB each, and stay within {maxFiles} files and {maxTotalMegabytes} MB total.",
  "promptInput.attachFiles.deviceRejected.other": "{count} selected files were not attached. Files must be readable, no larger than {maxFileMegabytes} MB each, and stay within {maxFiles} files and {maxTotalMegabytes} MB total.",
  "promptInput.clear.ariaLabel": "Clear prompt text",
  "promptInput.clear.title": "Clear prompt text",
  "promptInput.send.ariaLabel": "Send message",
  "promptInput.send.queueAriaLabel": "Queue message",
  "promptQueue.title": "Prompt queue ({count})",
  "promptQueue.delivery.queue": "Queued",
  "promptQueue.delivery.steer": "Steering",
  "promptQueue.attachments.one": "{count} attachment",
  "promptQueue.attachments.other": "{count} attachments",
  "promptQueue.actions.steer": "Steer now",
  "promptQueue.actions.queue": "Move to queue",
  "promptQueue.actions.edit": "Edit queued prompt",
  "promptQueue.actions.cancelEdit": "Cancel editing",
  "promptQueue.actions.remove": "Remove queued prompt",
  "promptQueue.error.title": "Queue action failed",
  "promptQueue.error.message": "Unable to update the prompt queue",
  "promptInput.send.errorFallback": "Failed to send message",
  "promptInput.send.errorTitle": "Send failed",
  "promptInput.conversationMode.enable.title": "Enable conversation mode",
  "promptInput.conversationMode.disable.title": "Disable conversation mode",
  "promptInput.conversationMode.error.title": "Conversation playback failed",
  "promptInput.conversationMode.error.message": "Unable to continue speaking assistant replies.",
  "promptInput.voiceInput.start.title": "Start voice input",
  "promptInput.voiceInput.stop.title": "Stop recording and transcribe",
  "promptInput.voiceInput.transcribing.title": "Transcribing audio",
  "promptInput.voiceInput.error.title": "Voice input failed",
  "promptInput.voiceInput.error.permission": "Microphone access is required to record voice input.",
  "promptInput.voiceInput.error.permissionDenied": "Microphone access was denied by macOS.",
  "promptInput.voiceInput.error.unsupported": "Voice input is not supported in this browser.",
  "promptInput.voiceInput.error.transcribe": "Unable to transcribe the recorded audio.",
  "promptInput.resizeHandle.title": "Drag to resize input height",
} as const
